/**
 * ReferralBlock_v2.jsx
 * Исправляет V16: реферальная ссылка теперь использует https:// вместо http://
 * Также: referralCode больше не передаётся как prop — грузится через API v2
 * (user_id не торчит в URL /api/get_referral_code.php?user_id=XXX)
 */

import React, { useEffect, useState } from "react";
import { Button, message, Spin } from "antd";
import { CopyOutlined, GiftOutlined, ShareAltOutlined } from "@ant-design/icons";
import { getReferralCode } from "../api_v2/subscription";

function ReferralBlockV2() {
  const [referralCode, setReferralCode] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getReferralCode()
      .then(({ success, referral_code }) => {
        if (success && referral_code) setReferralCode(referral_code);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  // https:// — исправлена уязвимость V16
  const referralLink = referralCode
    ? `https://simolapps.ru/register?ref=${referralCode}`
    : "";

  const copyReferralLink = () => {
    navigator.clipboard.writeText(referralLink)
      .then(() => message.success("Ссылка скопирована"))
      .catch(() => message.error("Не удалось скопировать ссылку"));
  };

  const shareReferralLink = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Присоединяйтесь ко мне!",
          text: "Присоединяйся к Simol Apps. После оплаты подписки я получу 14 дней в подарок.",
          url: referralLink,
        });
        message.success("Ссылка успешно отправлена!");
      } catch {
        message.warning("Отправка отменена.");
      }
    } else {
      navigator.clipboard.writeText(referralLink);
      message.success("Ссылка скопирована в буфер обмена.");
    }
  };

  return (
    <aside className="referral-card" aria-label="Реферальная программа">
      <span className="referral-card__icon" aria-hidden="true"><GiftOutlined /></span>
      <div className="referral-card__content">
        <strong>+14 дней за друга</strong>
        <span>После оплаты его подписки</span>
        {referralCode && <small title={referralLink}>{referralLink}</small>}
      </div>

      <div className="referral-card__actions">
        {loading ? (
          <Spin size="small" />
        ) : referralCode ? (
          <>
            <Button
              type="primary"
              icon={<CopyOutlined />}
              className="referral-card__copy"
              onClick={copyReferralLink}
            >
              Скопировать
            </Button>
            <Button
              icon={<ShareAltOutlined />}
              className="referral-card__share"
              aria-label="Поделиться реферальной ссылкой"
              onClick={shareReferralLink}
            />
          </>
        ) : (
          <span className="referral-card__unavailable">Ссылка пока недоступна</span>
        )}
      </div>
    </aside>
  );
}

export default ReferralBlockV2;
